import { FC } from "react";
import { Box, Card, Stack, Typography } from "@mui/joy";
import { useTranslation } from "react-i18next";

type ServiceCardPropsType = { title: string; icon: any; description: string };

export const ServiceCard: FC<ServiceCardPropsType> = ({
  title,
  icon: Icon,
  description,
}) => {
  const { t } = useTranslation();

  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        p: 3,
        bgcolor: "background.surface",
        backdropFilter: "blur(14px)",
        borderColor: "divider",
        boxShadow: "sm",
        transition: "0.25s ease",
        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: "lg",
          borderColor: "primary.300",
          "& .service-icon": {
            transform: "scale(1.08) rotate(-4deg)",
          },
        },
      }}
    >
      <Stack spacing={2.2} alignItems="center" textAlign="center">
        <Box
          className="service-icon"
          sx={{
            width: 74,
            height: 74,
            borderRadius: "24px",
            display: "grid",
            placeItems: "center",
            bgcolor: "primary.softBg",
            color: "primary.500",
            transition: "0.25s ease",
          }}
        >
          <Icon style={{ width: 42, height: 42 }} />
        </Box>

        <Stack spacing={1} alignItems="center">
          <Typography level="title-lg" noWrap>
            {t(title)}
          </Typography>
          <Typography
            level="body-sm"
            sx={{
              color: "text.secondary",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: "4",
              overflow: "hidden",
            }}
          >
            {t(description)}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
};
